module.exports = __webpack_public_path__ + "static/Banner-11-21ee413e630f5c4d7975baafa3311b0d.png";